import handleMediaQueryChange from "../components/helpers/_media_query";

const adjustMobileFooterForAds = () => {
    const footer = document.querySelector("#new-footer-layout");
    const banner = document.querySelector(".header-advertising");
    const gamblingAwareness = document.querySelector("#gambling-awareness");

    if (!banner || !footer || gamblingAwareness) return;

    const BANNER_PADDING = 10;

    footer.style.marginBottom = `${banner.clientHeight - BANNER_PADDING}px`;
};

const adjustDesktopFooterForAds = () => {
    const footer = document.querySelector("#new-footer-layout");
    const gamblingAwareness = document.querySelector("#gambling-awareness");

    if (!footer || gamblingAwareness) return;

    footer.style.marginBottom = "0";
};

export const setFooterSpacing = () => {
    handleMediaQueryChange(adjustMobileFooterForAds, adjustDesktopFooterForAds);
};
